import { render, staticRenderFns } from "./UserInfo.htm?vue&type=template&id=9040136a&scoped=true&"
import script from "./UserInfo.ts?vue&type=script&lang=js&"
export * from "./UserInfo.ts?vue&type=script&lang=js&"
import style0 from "./UserInfo.scss?vue&type=style&index=0&id=9040136a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9040136a",
  null
  
)

export default component.exports